import React from 'react';
import { Image } from 'react-bootstrap';
import {
    APP_STORE_LINK,
    GOOGLE_PLAY_LINK
} from '../constants/constants';

import appStore from '../assets/app-store.png';
import googlePlay from '../assets/google-play.png';

function DownloadLinks({ onClick }) {
    return (
        <span style={{ display: 'inline', textAlign: 'center' }}>
            Download our app:&nbsp;&nbsp;&nbsp;

            <a href={APP_STORE_LINK} target='_blank' aria-label="Download on the App Store" style={{ margin: '0 5px' }}>
                <img src={appStore} alt="App Store" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
            </a>
            <a href={GOOGLE_PLAY_LINK} target='_blank' aria-label="Get it on Google Play" style={{ margin: '0 5px' }}>
                <img src={googlePlay} alt="Google Play" style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }} />
            </a>

        </span>


    );
}

export default DownloadLinks;



// import React, { useState, useEffect } from 'react';
// import { Image } from 'react-bootstrap';
// import {
//     DEEP_LINK_URL,
//     APP_STORE_LINK,
//     GOOGLE_PLAY_LINK,
// } from '../constants/constants';

// import appStore from '../assets/app-store.png';
// import googlePlay from '../assets/google-play.png';

// function DownloadLinks({ onClick }) {
//     const [showFallback, setShowFallback] = useState(false);

//     const tryOpenApp = (event, storeUrl) => {
//         event.preventDefault(); // Prevent default link behavior
//         const appUrl = DEEP_LINK_URL || 'https://mybounceback.com/open'; // Fallback URL
//         let appOpened = false;

//         // Detect if the app opens (page loses focus)
//         window.addEventListener('blur', () => {
//             appOpened = true;
//         });

//         // Attempt to open the app
//         window.location = appUrl;

//         // Fallback if app isn’t installed (timeout)
//         setTimeout(() => {
//             if (!appOpened && document.hasFocus()) {
//                 // App not installed, redirect to the store or show fallback
//                 setShowFallback(true);
//                 window.location = storeUrl; // Redirect to store after showing fallback (optional)
//             }
//         }, 1000); // Adjust timeout as needed (500-1500ms)
//     };

//     // Optionally, detect mobile devices on mount to trigger deep linking automatically
//     useEffect(() => {
//         if (/Android|iPhone|iPad/i.test(navigator.userAgent) && window.innerWidth <= 768) {
//             // You can call tryOpenApp here if you want to auto-attempt opening the app on page load
//         }
//     }, []);

//     return (
//         <span style={{ display: 'inline', textAlign: 'center' }}>
//             Download our app:
//             <a
//                 href={APP_STORE_LINK}
//                 target='_blank'
//                 aria-label="Download on the App Store"
//                 style={{ margin: '0 5px' }}
//                 onClick={(e) => tryOpenApp(e, APP_STORE_LINK)}
//             >
//                 <img
//                     src={appStore}
//                     alt="App Store"
//                     style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }}
//                 />
//             </a>
//             <a
//                 href={GOOGLE_PLAY_LINK}
//                 target='_blank'
//                 aria-label="Get it on Google Play"
//                 style={{ margin: '0 5px' }}
//                 onClick={(e) => tryOpenApp(e, GOOGLE_PLAY_LINK)}
//             >
//                 <img
//                     src={googlePlay}
//                     alt="Google Play"
//                     style={{ verticalAlign: 'middle', width: 'auto', height: '40px' }}
//                 />
//             </a>
//             {showFallback && (
//                 <div
//                     style={{
//                         position: 'fixed',
//                         top: '20px',
//                         right: '20px',
//                         background: 'white',
//                         padding: '15px',
//                         borderRadius: '8px',
//                         boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//                         zIndex: 1000,
//                     }}
//                 >
//                     <span
//                         style={{ float: 'right', cursor: 'pointer' }}
//                         onClick={() => setShowFallback(false)}
//                     >
//                         X
//                     </span>
//                     <p>App not installed? Download it now!</p>
//                 </div>
//             )}
//         </span>
//     );
// }

// export default DownloadLinks;